"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const ArgusMenuDrawer_1 = tslib_1.__importDefault(require("./ArgusMenuBeta/ArgusMenuDrawer"));
const ArgusMenuComp_1 = tslib_1.__importDefault(require("./ArgusMenuComp"));
const utils_1 = require("./utils");
const ArgusMenu = ({ children, ...props }) => {
    // @ts-expect-error `isBeta` is defined as constant value in the interfaces.
    // In in this check is can be both true and false.
    if ((0, utils_1.isBetaConfig)(props))
        return (react_1.default.createElement(ArgusMenuDrawer_1.default
        // @ts-expect-error `isBeta` is defined as constant value in the interfaces.
        , { 
            // @ts-expect-error `isBeta` is defined as constant value in the interfaces.
            config: props, children: children, WrapperProps: {
                sx: {
                    "@media print": {
                        display: "none",
                    },
                },
            } }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ArgusMenuComp_1.default, { ...props }),
        children));
};
exports.default = ArgusMenu;
